
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { clearAllToasts } from '@/hooks/use-toast';
import { trackCurrentPage } from '@/utils/pageHistoryTracker';

/**
 * A lightweight component that handles route changes
 */
const NavigationGuard = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page navigation for returning users to their previous page
    trackCurrentPage(location.pathname);
    
    // Clear toasts when route changes
    clearAllToasts();
    
    // Scroll to top
    window.scrollTo(0, 0);
    
    // Log for debugging
    console.log(`Navigation: ${location.pathname}`);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default NavigationGuard;
